import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Entity, IRelatedEntity, RelatedEntity } from '@app/core/model/entities/entity';
import { Expose } from 'class-transformer';

export class Occupant extends Entity {
  public objectType = EntityTypeEnum.OCCUPANT;

  public identifier: number;
  public organizationId: string;
  public dataDate: string;

  @Expose()
  public toString(): string {
    return this.computedProperties?.['displayName'] ?? this.name;
  }

  /**
   * Transforms this Occupant to a RelatedOccupant.
   */
  public toRelatedOccupant(): RelatedOccupant {
    return new RelatedOccupant({
      id: this.id,
      name: this.name,
      identifier: this.identifier,
      displayName: this.computedProperties?.['displayName']
    });
  }
}

export type IRelatedOccupant = IRelatedEntity;

export class RelatedOccupant extends RelatedEntity implements IRelatedOccupant {
  constructor(relatedOccupant: IRelatedOccupant) {
    super(relatedOccupant);
  }
}

export interface OccupantInput {
  name?: string;
  dataDate?: string;
}
